module.exports = __webpack_public_path__ + "static/img/loginBg.979710b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Login/loginBg.jpeg
// module id = 2aP3
// module chunks = 37